import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { languageService } from "./lang/Lang.js";

// Import Privacy JSON files
import privacyDefaultEn from './legal/privacy-default-en.json';
import privacyDefaultAr from './legal/privacy-default-ar.json';
import privacyDefaultDe from './legal/privacy-default-de.json';
import privacyUaeEn from './legal/privacy-uae-en.json';
import privacyUaeAr from './legal/privacy-uae-ar.json';
import privacyUaeDe from './legal/privacy-uae-de.json';

const API_URL = process.env.REACT_APP_API_URL || 'https://sahra.ai/api';

export default function Privacy() {
  const [privacyContent, setPrivacyContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPrivacy = async () => {
      try {
        // Get user language
        const lang = (languageService.getLanguage() || 'en').toLowerCase();
        const isArabic = lang.startsWith('ar');
        const isGerman = lang.startsWith('de');

        // Check for URL parameter override (for testing)
        const urlParams = new URLSearchParams(window.location.search);
        const countryOverride = urlParams.get('country');

        // Fetch country from geo endpoint
        let country = 'XX';
        if (countryOverride) {
          // Use URL override if provided
          country = countryOverride.toUpperCase();
        } else {
          try {
            const response = await fetch(`${API_URL}/geo`);
            const data = await response.json();
            country = data.country || 'XX';
          } catch (geoError) {
            console.warn('Geo lookup failed, using default privacy:', geoError);
          }
        }

        // Select appropriate Privacy Policy based on country and language
        let privacy;
        if (country === 'AE') {
          // UAE jurisdiction
          if (isArabic) privacy = privacyUaeAr;
          else if (isGerman) privacy = privacyUaeDe;
          else privacy = privacyUaeEn;
        } else {
          // Default (Spain jurisdiction)
          if (isArabic) privacy = privacyDefaultAr;
          else if (isGerman) privacy = privacyDefaultDe;
          else privacy = privacyDefaultEn;
        }

        setPrivacyContent(privacy.privacy);
      } catch (error) {
        console.error('Error loading privacy:', error);
        // Fallback to default English privacy
        setPrivacyContent(privacyDefaultEn.privacy);
      } finally {
        setLoading(false);
      }
    };

    loadPrivacy();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '60px 20px', textAlign: 'center' }}>
        Loading...
      </div>
    );
  }

  return <div>{ReactHtmlParser(privacyContent)}</div>;
}
